<template>
  <div>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Szukaj"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="data" :search="search">
      <template v-slot:[`item.active`]="{ item }">
        <v-chip label dark small :color="item.active ? 'green' : 'red'">
          {{ item.active ? "Aktywny" : "Nieaktywny" }}
        </v-chip>
      </template>
      <template v-slot:[`item.role`]="{ item }">
        {{ item.role ? "Super Admin" : "Admin" }}
      </template>
      <template v-slot:[`item.options`]="{ item }">
        <v-btn color="primary" @click="userOptions(item)">
          <v-icon>
            mdi-account-edit
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <template>
      <v-btn dark fab color="success" class="add-btn" @click="addAdmin()">
        <v-icon dark>
          mdi-account-plus
        </v-icon>
      </v-btn>
    </template>
    <InfoModal
      :admin="admin"
      :open="open"
      :userInfo="userInfo"
      @close="close"
    />
    <AddNewAdminModal :openAdd="openAdd" @closeAdd="closeAdd" />
    <Snackbar :snackbar="snackbar" :snackbarStatus="snackbarStatus" />
  </div>
</template>

<script>
import axiosConf from "../../axios-conf";
import InfoModal from "@/components/InfoModal.vue";
import AddNewAdminModal from "@/components/AddNewAdminModal.vue";
import Snackbar from "@/components/Snackbar.vue";

export default {
  components: {
    InfoModal,
    AddNewAdminModal,
    Snackbar
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Imię",
          align: "start",
          value: "firstname"
        },
        { text: "Nazwisko", value: "lastname" },
        { text: "E-mail", value: "email" },
        { text: "Status", value: "active" },
        { text: "Rola", value: "role" },
        { text: "Opcje", value: "options" }
      ],
      data: [],
      open: false,
      openAdd: false,
      admin: true,
      userInfo: [],
      snackbar: false,
      snackbarStatus: false
    };
  },
  methods: {
    modalOpen(edit) {
      if (!edit) {
        this.userInfo = [];
      }
      this.open = true;
    },
    addAdmin() {
      this.openAdd = true;
    },
    close(status) {
      if (status !== "close") {
        this.snackbar = true;
        this.snackbarStatus = status;
        this.getData();
      }
      this.open = false;
    },
    closeAdd(status) {
      if (status !== "close") {
        this.snackbar = true;
        this.snackbarStatus = status;
        this.getData();
      }
      this.openAdd = false;
    },
    userOptions(user) {
      this.userInfo = user;
      this.modalOpen(true);
    },
    getData() {
      axiosConf
        .get("administrators.json", {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
          }
        })
        .then(response => {
          this.data = [...response.data];
        });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.add-btn {
  position: absolute;
  right: 20px;
  bottom: 20px;
}
</style>
